import { Injectable } from '@angular/core';
import { IVideoVendorService } from '../../../models/util/videoVendor';
import { IUploadTrackerConfig } from '../../../models/util/uploadFileTrackerConfig';
import { finalize, from, map, of, Subject, Subscription, switchMap } from 'rxjs';
import { isNullOrUndefined } from '@pineapplelab/util';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Injectable({
	providedIn: 'root'
})
export class FirebaseService implements IVideoVendorService {

	_cancelUpload$ = new Subject<void>();

	constructor(
		private fireStorage: AngularFireStorage
	) { }

	uploadFileWithListener(config: IUploadTrackerConfig): Subscription {
		let { path, file, onProgress, onSuccess, metadata, onError, onStarted } = config;
		if (isNullOrUndefined(metadata)) {
			metadata = { contentType: file.type };
		}
		const uploader = this.fireStorage.upload(path, file, metadata);
		const cancelSubscription = this._cancelUpload$.subscribe(() => uploader.task.cancel());

		const subscription = uploader.snapshotChanges().pipe(
			map(snapshot => (snapshot.bytesTransferred / snapshot.totalBytes) * 100),
			switchMap((progress) => {
				if (progress === 100) {
					return from(uploader.task).pipe(
						switchMap(taskSnapshot => taskSnapshot.ref.getDownloadURL())
					);
				}
				return of(Math.floor(progress));
			}),
			finalize(() => cancelSubscription.unsubscribe())
		).subscribe({
			next: async (data: number | string) => {
				if (typeof data === 'number') {
					onProgress(data);
				} else {
					await onSuccess(data);
				}
			},
			error: async (e) => await onError(e)
		});

		onStarted?.();

		return subscription;
	}

	async transcode(videoId: string): Promise<void> {
		// TODO: impl if project has google transcoder api, none yet
	}

}
